import * as actionType from './TrainingType'
import Subject from '@/models/Subject'
import Training from '@/models/Training'
import { isValid } from '@/utils/util'

export default {
  namespaced: true,
  state: {
    select: {
      year: 0,
      org: {},
      training: {}
    },
    training: {},
    subjects: {}
  },
  getters: {
    failScore: state => state.training && state.training.failScore,
    teacher: state => state.training && state.training.teacher.name,
    lecture: (state) => ({ category, subjectId, code }) => {
      if (!state.subjects[category]) return
      const subject = state.subjects[category].find(s => s._id === subjectId)
      const lecture = subject.lectures.find(l => l.code === code)
      return lecture
    }
  },
  mutations: {
    restoreTraining: (state) => {
      // 훈련 상태 복원
      const training = localStorage.getItem('training')
      if (isValid(training)) {
        state.training = JSON.parse(training)
      }
      // 교과목 복원
      const subjects = localStorage.getItem('subjects')
      if (isValid(subjects)) {
        state.subjects = JSON.parse(subjects)
      }
      // 선택지 복원
      const select = localStorage.getItem('select')
      if (isValid(select)) {
        state.select = JSON.parse(select)
      }
    },
    clearTraining: (state) => {
      localStorage.removeItem('training')
      localStorage.removeItem('select')
      localStorage.removeItem('subjects')
    },
    setSelect: (state, select) => {
      state.select = select
      localStorage.setItem('select', JSON.stringify(select))
    },
    [actionType.SET_TRAINING]: (state, training) => {
      state.training = training
      localStorage.setItem('training', JSON.stringify(training))
    },
    [actionType.SET_SUBJECTS]: (state, subjects) => {
      state.subjects = subjects
      localStorage.setItem('subjects', JSON.stringify(subjects))
    }
  },
  actions: {
    [actionType.GET_TRAININGS]: async ({ commit }, org) => {
      const res = await Training.get({ org })
      const { training, subjects } = res
      // commit(actionType.SET_TRAINING, training);
      // commit(actionType.SET_SUBJECTS, subjects);
      return subjects;
    },
    [actionType.GET_SUBJECTS]: async ({ commit }, trainingId) => {
      const subjects = await Subject.getSubjects(trainingId)
      commit(actionType.SET_SUBJECTS, subjects);
      return subjects;
    }
  }
}
